import React from 'react'
import Register from '../../componet/register/Register'

function RegisterPage() {
  return (
    <div>
        <Register/>
    </div>
  )
}

export default RegisterPage